module.exports = __webpack_public_path__ + "static/img/login_bg_2.78f60f7b.png";